import Theme from 'styles/theme'

import SurfboardIcon from '../../icons/Surfboard'
import CelebrateIcon from '../../icons/Celebrate'
import SummitIcon from '../../icons/Summit'
import TelescopeIcon from '../../icons/Telescope'
import HumanConnectionIcon from '../../icons/HumanConnection'
import FreedomIcon from '../../icons/Freedom'
import JoyIcon from '../../icons/Joy'

const values = [
  {
    text: 'We’re driven by our purpose and passion for adventure',
    Icon: SurfboardIcon,
    backgroundColor: Theme?.['-ds-information-100']?.value,
  },
  {
    text: 'Our community is at the heart of everything we do',
    Icon: CelebrateIcon,
    backgroundColor: Theme?.['-ds-core-50']?.value,
  },
  {
    text: 'We’re nimble, results-driven and always improving',
    Icon: SummitIcon,
    backgroundColor: Theme?.['-ds-neutral-200']?.value,
  },
  {
    text: 'We drive innovation through creativity',
    Icon: TelescopeIcon,
    backgroundColor: Theme?.['-ds-information-100']?.value,
  },
  {
    text: 'Our culture is defined through collaboration',
    Icon: HumanConnectionIcon,
    backgroundColor: Theme?.['-ds-core-50']?.value,
  },
  {
    text: 'We maintain balance through flexibility and freedom',
    Icon: FreedomIcon,
    backgroundColor: Theme?.['-ds-information-100']?.value,
  },
  {
    text: 'Our vibe is friendly, fun and upbeat',
    Icon: JoyIcon,
    backgroundColor: Theme?.['-ds-neutral-200']?.value,
  },
]

export default values
